import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AlertTriangle, X } from "lucide-react";

export function AIBudgetBanner() {
  const { t } = useTranslation();
  const [resetsAt, setResetsAt] = useState<string | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      const detail = (e as CustomEvent).detail as { resetsAt?: string } | undefined;
      if (detail?.resetsAt) setResetsAt(detail.resetsAt);
    };
    window.addEventListener("ai-budget-exceeded", handler);
    return () => window.removeEventListener("ai-budget-exceeded", handler);
  }, []);

  if (!resetsAt) return null;

  const ms = new Date(resetsAt).getTime() - Date.now();
  const hours = Math.max(1, Math.ceil(ms / 3_600_000));

  return (
    <div className="fixed top-0 inset-x-0 z-[100] bg-amber-950/95 border-b border-amber-500/40 backdrop-blur-md">
      <div className="max-w-5xl mx-auto px-4 py-3 flex items-start gap-3">
        <AlertTriangle className="w-5 h-5 text-amber-400 flex-shrink-0 mt-0.5" />
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-amber-200">
            {t("aiBudget.exceeded.title", "AI usage limit reached")}
          </div>
          <div className="text-xs text-amber-100/80 mt-0.5">
            {t("aiBudget.exceeded.body", "Your AI access resets in about {{hours}} hour(s).", { hours })}
          </div>
        </div>
        <button
          onClick={() => setResetsAt(null)}
          className="text-amber-300 hover:text-amber-100 flex-shrink-0"
          aria-label="Dismiss"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
